// Globals
import { useCallback } from 'react';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { loginUser, selectAuthIsLoading } from '../../feature';

// Components
import { LogInForm } from '../../components';

// Helpers
import { AUTHORIZATION_TOKEN_EXPIRES, AUTHORIZATION_TOKEN_STORAGE_KEY } from '@/constants/common';
import { appCookiesStorage } from '@/utils';
import LoginDTO from '../../dtos/LoginDTO';
import { TLogInFormValues } from '../../helpers/types';

const LogInContainer = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectAuthIsLoading);

  const handleSubmit = useCallback(
    async (values: TLogInFormValues) => {
      const loginDto = new LoginDTO(values);
      const payload = await dispatch(loginUser(loginDto)).unwrap();
      appCookiesStorage.setItem(AUTHORIZATION_TOKEN_STORAGE_KEY, payload.accessToken, {
        expires: AUTHORIZATION_TOKEN_EXPIRES,
      });
    },
    [dispatch],
  );

  return <LogInForm handleSubmit={handleSubmit} isLoading={isLoading} />;
};

export default LogInContainer;
